import moment from "moment";
import { DemoMachinesList } from "../adapters/DemoMachines/DemoMachinesList";

const IST_OFFSET_MINUTES = 330;
const UTC_RANGE_FORMAT = "YYYY-MM-DD HH:mm:ss";

export const getDemoListTimeRange = (days) => {
    const todayIst = moment().utcOffset(IST_OFFSET_MINUTES).startOf("day");
    const startUtc = todayIst.clone().subtract(Number(days), "days").utc();
    const endUtc = todayIst.clone().add(1, "day").utc();

    return {
        startTime: `${startUtc.format(UTC_RANGE_FORMAT)}+00`,
        endTime: `${endUtc.format(UTC_RANGE_FORMAT)}+00`,
    };
};

export const getDemoMachinesList = (days) => {
    const { startTime, endTime } = getDemoListTimeRange(days);
    var promise = new Promise(function (resolve, reject) {
        DemoMachinesList({
            startTime,
            endTime,
        }).then((res) => {
            if (res && res.data && res.status === 200) {
                let response = res.data;
                resolve(response);
            } else {
                if (res && res.data && res.data.error && res.data.error.message) reject(res.data.error.message);
                else reject("error occured");
            }
        }).catch((err) => {
            reject(err);
        });
    })

    return promise;
};
